module.exports = __webpack_public_path__ + "img/Nigeria.3e4d6773.svg";